import { Box } from 'components/layouts/primitives/Box/Box';
import styled from 'styled-components';
import { colourPalette } from 'styles/styles';

export const FileUploadListStyle = {
  Item: styled(Box)`
    &:hover {
      background-color: ${colourPalette.neutral100};
      .file-list-item-close {
        display: flex;
        align-items: center;
      }
    }
  `,
  EmptyContainer: styled.div`
    height: 120px;
  `,
};
